import { createSlice } from "@reduxjs/toolkit";
import { CatalogInitialStore } from "./types.store";
// eslint-disable-next-line import/no-cycle
import {
  handleGetCatalogAreaRequest,
  handleGetCatalogProductsRequest,
} from "./thunk.store";

const initialState: CatalogInitialStore = {
  coverageArea: null,
  catalogProducts: null,
};

const CatalogStore = createSlice({
  initialState,
  name: "CatalogData",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(handleGetCatalogAreaRequest.fulfilled, (state, action) => {
      if (!action.payload.data) {
        return;
      }

      const coverageArea = (state.coverageArea || []).filter(
        (area) => area.coverageAreaId !== action.payload.data.coverageAreaId,
      );
      state.coverageArea = coverageArea.concat(action.payload.data) || null;
    });
    builder.addCase(
      handleGetCatalogProductsRequest.fulfilled,
      (state, action) => {
        state.catalogProducts = action.payload;
      },
    );
  },
});

export default CatalogStore.reducer;
